export default __webpack_public_path__ + "static/media/030-scooter.ba516ca6.png";